import Vue from 'vue';
import AppSpinner from '@/components/ui/AppSpinner';
import AppFooter from '@/components/ui/Footer';

export default () => {
    Vue.component('app-spinner', AppSpinner);
    Vue.component('app-footer', AppFooter);
}